// extracted by mini-css-extract-plugin
export default {"link":"CancelCampaignCreationButton_link__Au-fP"};